var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "20px",
    viewBox: "0 0 31 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logos/ cc/mc") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "6.59574468e-05 0.216444444 30.954995 0.216444444 30.954995 19.9999333 6.59574468e-05 19.9999333"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logos/-cc/mc",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.954995,17.7777111 C30.954995,18.9999333 29.9656333,19.9999333 28.7564135,19.9999333 L2.19864752,19.9999333 C0.98942766,19.9999333 6.59574462e-05,18.9999333 6.59574462e-05,17.7777111 L6.59574462e-05,2.4386 C6.59574462e-05,1.21637778 0.98942766,0.216377778 2.19864752,0.216377778 L28.7564135,0.216377778 C29.9656333,0.216377778 30.954995,1.21637778 30.954995,2.4386 L30.954995,17.7777111 Z",
    id: "Fill-1",
    fill: "#050302",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19,13.8801583 C19,15.0460712 17.9999365,16 16.7776367,16 L14.2223633,16 C13.0000635,16 12,15.0460712 12,13.8801583 L12,6.11984172 C12,4.95392877 13.0000635,4 14.2223633,4 L16.7776367,4 C17.9999365,4 19,4.95392877 19,6.11984172 L19,13.8801583 Z",
    id: "Fill-4",
    fill: "#F16522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9306083,10 C12.9306083,7.448 14.1308692,5.17511111 16,3.71022222 C14.6330237,2.63888889 12.9087366,2 11.0344727,2 C6.59721197,2 3,5.58155556 3,10 C3,14.4184444 6.59721197,18 11.0344727,18 C12.9087366,18 14.6330237,17.3611111 16,16.2897778 C14.1308692,14.8251111 12.9306083,12.552 12.9306083,10",
    id: "Fill-6",
    fill: "#E52523"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9577836,16 C27.9808707,16 28,15.7750716 28,15.5 C28,15.2249284 27.9729551,15 27.9399736,15 C27.9069921,15 27.8486148,15.1540115 27.810686,15.3438395 C27.7724274,15.5336676 27.7100923,15.5336676 27.6721636,15.3438395 C27.6342348,15.1540115 27.5761873,15 27.542876,15 C27.5098945,15 27.4828496,15.2249284 27.4828496,15.5 C27.4828496,15.7750716 27.5019789,16 27.525066,16 C27.5488127,16 27.5676121,15.8302292 27.5676121,15.6232092 C27.5676121,15.4154728 27.5966359,15.3918338 27.6325858,15.5702006 C27.667876,15.7492837 27.7170185,15.8954155 27.7414248,15.8954155 C27.7655013,15.8954155 27.8146438,15.7492837 27.8502639,15.5694842 C27.8858839,15.3904011 27.9152375,15.4140401 27.9152375,15.6224928 C27.9152375,15.8302292 27.9343668,16 27.9577836,16 M27.1959103,16 C27.2189974,16 27.2377968,15.8130372 27.2377968,15.5852436 C27.2377968,15.3574499 27.2727573,15.1704871 27.3149736,15.1704871 C27.3575198,15.1704871 27.3921504,15.1318052 27.3921504,15.0859599 C27.3921504,15.0393983 27.3040897,15.0007163 27.1959103,15.0007163 C27.0880607,15.0007163 27,15.0393983 27,15.0859599 C27,15.1318052 27.0343008,15.1704871 27.076847,15.1704871 C27.1193931,15.1704871 27.1536939,15.3574499 27.1536939,15.5852436 C27.1536939,15.8130372 27.1728232,16 27.1959103,16",
    id: "Fill-8",
    fill: "#F89E1B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9655273,2 C18.0914865,2 16.3669763,2.63888889 15,3.71022222 C16.8691308,5.17488889 18.0693917,7.448 18.0693917,10 C18.0693917,12.552 16.8691308,14.8251111 15,16.2897778 C16.3669763,17.3611111 18.0914865,18 19.9655273,18 C24.4030112,18 28,14.4184444 28,10 C28,5.58155556 24.4030112,2 19.9655273,2",
    id: "Fill-10",
    fill: "#F89E1B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.5e369862.svg";
export { ForwardRef as ReactComponent };